import {
    getApiBaseUrl as getConfiguredApiBaseUrl,
    getApiKey as getConfiguredApiKey,
    toMockErrorResponse,
    toMockResponse,
} from '../apiConfig'
import Mock from '../mock'
import axios from 'axios.js'
const getApiBase = () => getConfiguredApiBaseUrl()
const getApiKey = () => getConfiguredApiKey()
const sanitizeFrontpadDebugPayload = (payload) => {
    try {
        return JSON.parse(JSON.stringify(payload, (key, value) => (
            key === 'api_key' || key === 'Authorization' || key === 'authorization' ? '[скрыто]' : value
        )))
    } catch (e) {
        return { debug_parse_error: e?.message || String(e), payload_type: typeof payload }
    }
}

Mock.onGet('/api/frontpad/sync/settings').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/sync/settings/get/`)
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad sync settings get error', e)
        return toMockErrorResponse(e, 'Ошибка получения настроек синхронизации FrontPad')
    }
})

Mock.onPost('/api/frontpad/sync/settings/save').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/sync/settings/save/`, data)
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad sync settings save error', e)
        return toMockErrorResponse(e, 'Ошибка сохранения настроек синхронизации FrontPad')
    }
})

Mock.onPost('/api/frontpad/sync/test').reply(async () => {
    try {
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/sync/test/`, {})
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad sync test error', e)
        return toMockErrorResponse(e, 'Ошибка проверки подключения к FrontPad')
    }
})

Mock.onPost('/api/frontpad/sync/preview').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/sync/preview/`, data)
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad sync preview error', e)
        return toMockErrorResponse(e, 'Ошибка получения предпросмотра синхронизации')
    }
})

Mock.onPost('/api/frontpad/sync/apply').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/sync/apply/`, data)
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad sync apply error', e)
        return toMockErrorResponse(e, 'Ошибка применения синхронизации')
    }
})

Mock.onPost('/api/frontpad/sync/run-auto').reply(async () => {
    try {
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/sync/run-auto/`, {})
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad sync run-auto error', e)
        return toMockErrorResponse(e, 'Ошибка запуска авто-синхронизации')
    }
})

Mock.onGet('/api/frontpad/sync/logs').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/sync/logs/`)
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad sync logs error', e)
        return toMockErrorResponse(e, 'Ошибка получения логов синхронизации')
    }
})

Mock.onGet('/api/frontpad/order-export/settings').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/order-export/settings/get/`)
        console.group('[FrontPad][backend] GET settings')
        console.log('HTTP status:', response?.status)
        console.log('Response:', sanitizeFrontpadDebugPayload(response?.data))
        console.groupEnd()
        if (!response?.data || typeof response.data !== 'object') {
            return [500, {
                error: 'Invalid FrontPad Settings Response',
                errorInfo: 'Backend FrontPad вернул не JSON. Точная ошибка выведена в консоль.',
            }]
        }
        return toMockResponse(response)
    } catch (e) {
        console.group('[FrontPad][backend] GET settings ERROR')
        console.error('Message:', e?.message || String(e))
        console.error('HTTP status:', e?.response?.status)
        console.error('Response:', sanitizeFrontpadDebugPayload(e?.response?.data))
        console.groupEnd()
        return toMockErrorResponse(e, 'Ошибка получения настроек экспорта заказов FrontPad')
    }
})

Mock.onPost('/api/frontpad/order-export/settings/save').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/order-export/settings/save/`, data)
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad order export settings save error', e)
        return toMockErrorResponse(e, 'Ошибка сохранения настроек экспорта заказов FrontPad')
    }
})

Mock.onPost('/api/frontpad/order-export/route/delete').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/order-export/route/delete/`, data)
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad orphaned route delete error', e)
        return toMockErrorResponse(e, 'Ошибка окончательного удаления маршрута FrontPad')
    }
})

Mock.onGet('/api/frontpad/order-export/logs').reply(async (config) => {
    try {
        const params = config?.params || {}
        const query = new URLSearchParams()
        if (params?.order_id) query.set('order_id', String(params.order_id))
        if (params?.limit) query.set('limit', String(params.limit))
        const qs = query.toString()
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/order-export/logs/get/${qs ? `&${qs}` : ''}`)
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad order export logs get error', e)
        return toMockErrorResponse(e, 'Ошибка получения логов экспорта заказов FrontPad')
    }
})

Mock.onPost('/api/frontpad/order-export/retry').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/order-export/retry/`, data)
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad order export retry error', e)
        return toMockErrorResponse(e, 'Ошибка повторной отправки заказа в FrontPad')
    }
})

Mock.onPost('/api/frontpad/order-export/process').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=frontpad/order-export/process/`, data)
        return toMockResponse(response)
    } catch (e) {
        console.error('frontpad order export process error', e)
        return toMockErrorResponse(e, 'Ошибка обработки очереди FrontPad')
    }
})
